import React from 'react'

const Case = () => {
  return (
    <div>
      <h1>case shops</h1>
    </div>
  )
}

export default Case
